if (!customElements.get('cookie-banner')) {
  customElements.define(
    'cookie-banner',
    class CookieBanner extends ModalElement {
      constructor() {
        super();

        setTimeout(() => this.bindPolicyButtons(), 0);
        setTimeout(() => this.bindPolicyButtons(), 1000);
    
        if (!theme.config.isTouch || Shopify.designMode) {
          this.init();
        }
        else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }
    
      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }
    
      get delay() {
        return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5;
      }
    
      get acceptButton() {
        return this.querySelector('button[name="accept"]');
      }
    
      get declineButton() {
        return this.querySelector('button[name="decline"]');
      }

      get preferenceButtons() {
        return Array.from(document.querySelectorAll('[data-cookie-preferences]'));
      }
    
      init() {
        if (this.initialized) return;
        this.initialized = true;
        this.bindPolicyButtons();
    
        if (this.testMode) {
          this.load(this.delay);
          return;
        }
    
        window.Shopify.loadFeatures([{
          name: 'consent-tracking-api',
          version: '0.1',
          onLoad: this.onConsentLibraryLoaded.bind(this)
        }]);
      }
    
      load(delay) {
        if (Shopify.designMode) return;
    
        setTimeout(() => this.show(), delay * 1000);
        this.bindPolicyButtons();
      }

      bindPolicyButtons() {
        if (this.policyButtonsBound) return;

        let bound = false;
        if (this.acceptButton) {
          this.acceptButton.addEventListener('click', this.acceptPolicy.bind(this));
          bound = true;
        }
        if (this.declineButton) {
          this.declineButton.addEventListener('click', this.declinePolicy.bind(this));
          bound = true;
        }
        this.preferenceButtons.forEach((button) => {
          if (button.dataset.cookiePreferencesBound === 'true') return;
          button.dataset.cookiePreferencesBound = 'true';
          button.addEventListener('click', (event) => {
            event.preventDefault();
            this.show(button);
          });
          bound = true;
        });

        if (bound) this.policyButtonsBound = true;
      }
    
      acceptPolicy() {
        window.Shopify.customerPrivacy?.setTrackingConsent(true, this.noop);
        this.closeBanner();
        document.dispatchEvent(new CustomEvent('volturaTrackingConsentUpdated', { detail: { accepted: true } }));
    
        document.addEventListener('trackingConsentAccepted', () => {
          console.log('trackingConsentAccepted event fired');
        });
      }
    
      declinePolicy() {
        window.Shopify.customerPrivacy?.setTrackingConsent(false, this.noop);
        this.closeBanner();
        document.dispatchEvent(new CustomEvent('trackingConsentDeclined'));
        document.dispatchEvent(new CustomEvent('volturaTrackingConsentUpdated', { detail: { accepted: false } }));
      }

      closeBanner() {
        this.removeAttribute('open');
        this.removeAttribute('active');
        this.setAttribute('inert', '');
        this.hidden = true;
        document.body.classList.remove('has-cookie-banner');

        this.controls.forEach((button) => button.setAttribute('aria-expanded', 'false'));
      }
    
      onConsentLibraryLoaded() {
        const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
        const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();
    
        if(!userCanBeTracked && userTrackingConsent === 'no_interaction') {
          this.load(this.delay);
        }
      }
    
      noop() {
      }
    
      afterHide() {
        super.afterHide();
        document.body.classList.remove('has-cookie-banner');
      }
      afterShow() {
        super.afterShow();
        document.body.classList.add('has-cookie-banner');
      }
    }
  );
}
